module.exports = __webpack_public_path__ + "img/goi-di.6375b64c.svg";